
import { Vue } from "vue-class-component";

export default class Invisible extends Vue {}
